import { FC, useEffect, useRef } from 'react';

// Shadow DOM here provides STYLE isolation only — it is NOT an XSS boundary.
// Callers must pass HTML that has already been sanitised (or produced by a
// trusted pipeline with auto-escaping). The shadow root inherits the parent
// document's origin, so any script in `html` runs with full access to the
// surrounding page's auth state.
const ShadowDomRenderer: FC<{
  html: string;
  className?: string;
  'data-testid'?: string;
}> = (props) => {
  const { html, className, 'data-testid': dataTestId } = props;

  const shadowHostRef = useRef<HTMLDivElement>(null);
  const shadowRootRef = useRef<ShadowRoot | null>(null);

  useEffect(() => {
    if (shadowHostRef.current && !shadowRootRef.current) {
      // Attach shadow DOM only once
      shadowRootRef.current = shadowHostRef.current.attachShadow({
        mode: 'open',
      });
    }

    if (shadowRootRef.current) {
      // Update shadow DOM content on each html change
      shadowRootRef.current.innerHTML = html;
    }
  }, [html]);

  return (
    <div
      ref={shadowHostRef}
      className={className}
      data-testid={dataTestId}
    ></div>
  );
};

export default ShadowDomRenderer;
